import { useState, useCallback } from 'react';
import Axios from 'axios';

const usePost = (url, data, after) => {
	const [pending, setPending] = useState(false);
	const [response, setResponse] = useState(null);
	const [error, setError] = useState(null);
	const post = useCallback(() => {
		setPending(true);
		setResponse(null);
		setError(null);
		const formData = Object.keys(data).reduce((fd, key) => {
			fd.set(key, data[key]);
			return fd;
		}, new FormData());
		return Axios.post(url, formData, {
			headers: {
				'Content-Type': 'multipart/form-data;'
			} })
			.then(resp => {
				if (after && typeof after === 'function') {
					after();
				}
				setResponse(resp.data);
			})
			.catch(err => { setError(err); })
			.finally(() => { setPending(false); });
	}, [url, after, data]);

	return [post, pending, response, error];
};

export default usePost;



// WEBPACK FOOTER //
// ./src/hooks/UsePost.js